import React from "react";

export const ShoppingIconSvg = ({size = 20, ...props}) => {
    return (
        <svg
            {...props}
            width={size} height={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48">
            <path fill="currentColor" d="M44.952 40.303l-2.33-15.15A2.524 2.524 0 0040.111 23H24.29a2.524 2.524 0 00-2.509 2.153l-2.33 15.15A4.077 4.077 0 0023.48 45h17.442a4.078 4.078 0 004.03-4.697zm-7.904-9.38a4.846 4.846 0 11-9.693 0v-.77a1 1 0 012 0v.77a2.846 2.846 0 105.693 0v-.77a1 1 0 012 0zM29 13H13a1 1 0 01-1-1 9 9 0 0118 0 1 1 0 01-1 1zm-14.929-2H27.93a7 7 0 00-13.858 0z" />
            <path fill="currentColor" d="M35.97 14.66A4.035 4.035 0 0031.94 11H10.06a4.035 4.035 0 00-4.03 3.66L3.56 40.57A4.05 4.05 0 007.59 45h12.08a5.814 5.814 0 01-.42-.44 5.571 5.571 0 01-1.28-4.48l2.33-15.16a4.01 4.01 0 013.99-3.42h12.33zM13 18.75A1.75 1.75 0 1114.75 17 1.75 1.75 0 0113 18.75zm16 0A1.75 1.75 0 1130.75 17 1.75 1.75 0 0129 18.75z" />
        </svg>
    );
}